// Services Imports
import { fetchAssetsByAccount, fetchAllAccounts } from "./assetsServices";
import { fetchAllDocumentTypes } from "../DocumentActions/services";

export const getAssetInitData = () => async dispatch => {
  try {
    const accounts = await fetchAllAccounts();
    const docTypes = await fetchAllDocumentTypes();

    Promise.all([accounts, docTypes])
      .then(response => {
        dispatch({
          type: "ASSETS_INIT_DATA",
          payload: response,
        });
      })
      .catch(error => {
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const getAssetsByAccount = accountId => dispatch =>
  new Promise((resolve, reject) => {
    fetchAssetsByAccount(accountId)
      .then(response => {
        dispatch({
          type: "ASSETS_BY_ACCOUNT",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getDocumentTypes = () => dispatch =>
  new Promise((resolve, reject) => {
    fetchAllDocumentTypes()
      .then(response => {
        dispatch({
          type: "FETCH_DOCUMENT_TYPES",
          payload: response.DocumentTypes,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
